<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ 'MODAL_HEADER' | globalTranslate }}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate"  (click)="onConfirm()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
    </button>
  </div>

  <div class="modal-body">
    <p class="m-3">{{'MODAL_DESC' | globalTranslate}}</p>
    <div class="m-3">
      <p class="mb-2">
        {{'MODAL_DESC2' | globalTranslate}}<b>{{'MODAL_CONTINUE' | globalTranslate}}</b> {{'MODAL_DESC2_1' | globalTranslate}} <b>{{'MODAL_EXIT' | globalTranslate}}</b>. {{'MODAL_DESC2_2' | globalTranslate}}
      </p>
      <p class="mb-2">
        {{'MODAL_DESC3' | globalTranslate}}<b>{{'MODAL_CONTINUE' | globalTranslate}}</b>{{'MODAL_DESC3_1' | globalTranslate}}<b>{{'MODAL_EXIT' | globalTranslate}}</b> {{'MODAL_DESC3_2' | globalTranslate}}
      </p>
      <p class="mb-2">{{'MODAL_DESC4' | globalTranslate}}<b>{{'MODAL_EXIT' | globalTranslate}}</b>.</p>
      <p class="mb-2"> {{'MODAL_DESC5' | globalTranslate}}<b>{{'MODAL_CONTINUE' | globalTranslate}}</b>{{'MODAL_DESC5_1' | globalTranslate}}</p>
    </div>
  </div>

  <!-- Standard markup for a 2 buttons footer; just change the button names & events -->
  <div class="modal-footer d-flex flex-column flex-md-row justify-content-center w-100">
  
        <button type="button" id="modal-submit-action" class="btn btn-secondary mb-2 mb-md-0 me-md-5" (click)="onConfirm()">{{'MODAL_CONTINUE' | globalTranslate}}</button>

        <button type="button" id="modal-cancel-action" class="btn btn-primary" style="margin-left: 0;" (click)="onCancel()">{{'MODAL_EXIT' | globalTranslate}}</button>

 
  </div>
</div>
